import { ComponentProvider } from '@phi/vue-router';
import { Option } from '@vaaas/fpts/option';
import { ref, shallowRef } from 'vue';

export const pop_under_with_router_state_provider = () => {
    const showing_pop_under = ref(false);
    const pop_under_white = ref(false);
    const route = shallowRef<Option<ComponentProvider>>(undefined);
    return { showing_pop_under, pop_under_white, route };
};
